import { render } from "./CustomDropdown.vue?vue&type=template&id=5091807a&scoped=true"
import script from "./CustomDropdown.vue?vue&type=script&lang=js"
export * from "./CustomDropdown.vue?vue&type=script&lang=js"

import "./CustomDropdown.vue?vue&type=style&index=0&id=5091807a&scoped=true&lang=css"

import exportComponent from "/home/le01s/WebstormProjects/am_logger_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5091807a"]])

export default __exports__